import React, { useRef, useEffect, memo } from 'react'
import Highcharts from 'highcharts'
import Histogram from 'highcharts/modules/histogram-bellcurve'
import HighchartsReact from 'highcharts-react-official'
import styled from 'styled-components'
import HighchartsLegends from './components/HighchartsLegends'
import Loading from 'live/components/ui/Loading'
import { ChartOptions } from './ChartOptions'
import { WaitingEvents } from './components/WaitingEvents'

Histogram(Highcharts)

export const Chart = props => {
    const { loading = true, events } = props?.state

    if (loading) return <Loading />
    if (events.length == 0) return <WaitingEvents />

    const chartRef = useRef()

    useEffect(() => {
        if (chartRef.current) {
            const { chart } = chartRef.current as {
                chart: Highcharts.Chart
            }
            chart.reflow()
        }
    }, [props.width, props.height])

    const Coptions = React.useMemo(() => ChartOptions(props), [props.state, props.widget])

    return (
        <Container>
            {' '}
            <HighchartsContainer>
                <HighchartsReact
                    ref={chartRef}
                    constructorType={'chart'}
                    highcharts={Highcharts}
                    options={Coptions}
                    containerProps={{ style: { height: '100%', width: '100%' } }}
                />
            </HighchartsContainer>
            <HighchartsLegends />
        </Container>
    )
}

export default memo(Chart)

const HighchartsContainer = styled.div`
    height: 100% !important;
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;

    > div:last-child,
    .highcharts-container {
        width: 100% !important;
        height: 100% !important;
    }
`
